export default (config => {
  const {
    mock = process.env.REACT_APP_USE_MOCK === "true",
    setup
  } = config;
  if (mock === false) return;
  setup();
});